import { Button, Classes, Dialog } from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IEmpresaNotaManual } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { NotasStore } from "../../stores/notas/NotasStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";

interface LogsPageState {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class NotasManual extends React.Component<any, LogsPageState> {
  constructor(props: {}) {
    super(props);

    NotasStore.obs.openModal = true;
  }

  componentDidMount() {
  }

  handleCloseModal() {
    NotasStore.obs.openModal = false;
  }

  async handleDelNotasManual() {
    await NotasStore.deleteNotasManual();

    if (NotasStore.obs.result_ok) {
      toast.success('Gravações efetuadas', {});
      await NotasStore.loadAtrasadasManual();
      ResultadoStore.obs.notasManual = false;
    } else {
      toast.error('Erro ao efetuar Gravações', {});
    }
  }

  render() {
    return (
      <>
        <Dialog
          isOpen={NotasStore.obs.openModal}
          title="Atenção"
          onClose={() => this.handleCloseModal()}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="12">
                <h3 className="titleProccess">
                  Esta(s) empresa(s) estão com nota(s) cujo o mês do cálculo
                  esta diferente do mês da emissão, como são empresas
                  COMPETÊNCIA isso impacta no fechamento do mês
                </h3>
                <h3 className="titleProccess">
                  <u>
                    Você tem a opção de manter assim ou contestar os itens para
                    a mesma data da emissão da nota, se desejar mater as datas
                    diferentes basta clicar no botão SIM
                  </u>
                </h3>
              </MDBCol>
            </MDBRow>

            <div style={{ marginBottom: 10, display: "flex", flexWrap: "wrap", justifyContent: "space-between" }} className="AlertImportacoes">

              {NotasStore.obs.empresasAtrasadasManual?.map(
                (el: IEmpresaNotaManual) => {
                  return (
                    <div style={{ width: "50%" }}>

                      <div className={Classes.DIALOG_BODY} >
                        <div className="bloco-emp-erro noPointer">
                          <table style={{ width: "100%" }}>
                            <thead>
                              <tr>
                                <th style={{ width: "100%" }}>
                                  {el.razao_social}
                                </th>
                                <th style={{ width: "5%", float: "right" }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{el.cnpj_destino}</td>

                                <td>
                                  <span className="badge-emp pulse badge-emp-calculo">
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  );
                },
              )}
            </div>

            <Button
              onClick={() => this.handleDelNotasManual()}
              className="certiDigitalTeste"
              style={{ marginBottom: -50 }}
            >
              SIM, desejo manter o mês do calculo dferente da emissão (PARA
              TODAS EMPRESAS LISTADAS)
            </Button>
            <Button
              onClick={() => this.handleCloseModal()}
              className="closeRetroativas"
              style={{ marginBottom: -50 }}
            >
              Fechar
            </Button>
          </div>
        </Dialog>
      </>
    );
  }
}
